export enum GoalStatsScope {
    OWNED = 'OWNED',
    PERSONAL = 'PERSONAL',
    COMPANY = 'COMPANY',
    DEPARTMENT = 'DEPARTMENT',
    OFFICE_LOCATION = 'OFFICE_LOCATION',
    TEAM = 'TEAM',
    ALL = 'ALL',
    REPORTING_LINE = 'REPORTING_LINE'
}